<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">
    <data-view-sidebar
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      :data="sidebarData"
    />

    <vs-table
      ref="table"
      :multiple="false"
      v-model="selected"
      search
      :data="respDataPoll"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div
          class="flex flex-wrap-reverse items-center data-list-btn-container"
        >
          <!-- ADD NEW -->
          <div
            class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
            @click="addNewData"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">{{
              "Add New" || "Add New"
            }}</span>
          </div>
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown
          vs-trigger-click
          class="cursor-pointer mb-4 mr-4 items-per-page-handler"
        >
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <!-- <span
              class="mr-2"
            >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ queriedItems - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : queriedItems }} {{$t('of')}} {{ queriedItems }}</span>-->
            <span>{{ "10" }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="pageSize(2)">
              <span>2</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="pageSize(10)">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="pageSize(20)">
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="pageSize(50)">
              <span>50</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="pageSize(100)">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th>{{ "Logo" }}</vs-th>
        <vs-th sort-key="Name">{{ "Pin" }}</vs-th>
        <vs-th sort-key="Code">{{ "Topic" }}</vs-th>
        <!-- <vs-th sort-key="Status">{{ "Detail" }}</vs-th> -->
        <vs-th sort-key="Status">{{ "Status" }}</vs-th>
        <vs-th sort-key="Create">{{ "Create" }}</vs-th>
        <vs-th>{{ "Actions" || "Actions" }}</vs-th>
      </template>

      <template v-if="data" slot-scope="{ data }">
        <tbody>
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td class="img-container">
              <img
                :src="require(`@/assets/images/NO_IMG.png`)"
                class="product-img"
              />
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.pin }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.topic }}</p>
            </vs-td>

            <!-- <vs-td>
              <p class="product-name font-medium truncate">{{ tr.detail }}</p>
            </vs-td> -->

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.status }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">
                {{ "10-09-2020" }}
              </p>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon
                icon="LogInIcon"
                class="ml-2"
                svgClasses="w-5 h-5 hover:text-success stroke-current"
                @click.stop="viewData(tr)"
              />
              <feather-icon
                icon="EditIcon"
                class="ml-2"
                svgClasses="w-5 h-5 hover:text-success stroke-current"
                @click.stop="editData(tr)"
              />
              <feather-icon
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click.stop="deleteData(tr, indextr)"
              />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>


<script>
import DataViewSidebar from "./DataViewSidebar.vue";
import moduleDataList from "@/store/Poll/moduleDataList.js";

// import moduleDataList from "@/store/admin/apps/moduleDataList.js";
import vSelect from "vue-select";

export default {
  components: {
    DataViewSidebar,
    vSelect,
  },
  data() {
    return {
      dataApp: "",
      dataPackage: "",
      popupActive: false,
      selected: [],
      itemsPerPage: localStorage.getItem("itemsPerPage")
        ? parseInt(localStorage.getItem("itemsPerPage"))
        : 10,
      isMounted: false,

      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
    };
  },
  computed: {
    respDataPoll() {
      return this.$store.state.poll.respData || [];
    },
  },
  methods: {

    viewData(data) {
      this.$router.push({ path: `/Poll/View/${data.key}` });
    },
    editData(data) {
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    },
    pageSize(size) {
      //   localStorage.setItem("itemsPerPage", size);

      if (size == "all") {
        this.itemsPerPage = this.queriedItems;
      } else {
        this.itemsPerPage = size;
        if (this.queriedItems < this.itemsPerPage * this.currentPage) {
          this.currentPage = 1;
        }
      }
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
    addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
    deleteData(data, index) {
      this.$vs.dialog({
        type: "confirm",
        color: "success",
        title: "Confirm",
        acceptText: "Accept",
        cancelText: "Cancel",
        text: "You want to Delete" + " " + data.name + " ?",
        accept: () => {
          const obj = {
            data: data,
            index: index,
          };
          this.$vs.loading();
          this.$store
            .dispatch("poll/DeleteData", obj)
            .then((res) => {
              this.$vs.loading.close();
              this.$vs.notify({
                title: "Delete Success",
                text: res,
                iconPack: "feather",
                icon: "icon-tash",
                color: "success",
              });
            })
            .catch((err) => {
              this.$vs.loading.close();
              console.log(err);
            });
        },
      });
    },
  },
  created() {
    if (!moduleDataList.isRegistered) {
      this.$store.registerModule("poll", moduleDataList);
      moduleDataList.isRegistered = true;
    }

    var Uid = this.$store.state.AppActiveUser.uid;
    this.$vs.loading();
    this.$store
      .dispatch("poll/GetData", Uid)
      .then((res) => {
        this.$vs.loading.close();
      })
      .catch((err) => {
        this.$vs.loading.close();
      });
  },
  // mounted() {
  //   this.isMounted = true;
  // },
};
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 10px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
          &.img-container {
            // width: 1rem;
            // background: #fff;

            span {
              display: flex;
              justify-content: flex-start;
            }

            .product-img {
              height: 110px;
            }
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
